<template>
  <div>
      <!-- key on farmId so switching farms fully re-mounts the sub-page and
           re-fetches data for the newly selected farm -->
      <router-view :key="$route.params.farmId" />
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>